import { Button } from "@components/Button";
import { ButtonSize } from "@components/Button/types";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { H1, Title2 } from "@components/Typography";
import { useModal } from "@hooks";
import { i18n, Translations } from "@i18n";
import { Container, styles } from "./styles";
import { SuccessModalProps } from "./types";

export const SuccessModal = ({ onClick: onClickProp }: SuccessModalProps) => {
  const { dismiss } = useModal();

  const onClick = () => {
    dismiss();
    onClickProp();
  };

  return (
    <Container style={styles.container}>
      <span style={styles.icon}>🎉</span>
      <Spacing size={SpacingSizes.XS} />

      <H1 style={styles.title}>{i18n.t(Translations.SuccessModalTitle)}</H1>
      <Spacing size={SpacingSizes.XL} />

      <Title2 style={styles.subtitle}>{i18n.t(Translations.SuccessModalSubtitle)}</Title2>
      <Spacing size={SpacingSizes.XXL} />

      <Button
        title={i18n.t(Translations.SuccessModalPrimaryCTA)}
        size={ButtonSize.Small}
        buttonStyle={styles.button}
        textStyle={styles.buttonText}
        onClick={onClick}
      />
    </Container>
  );
};
